import _classCallCheck from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/Users/ashokmandal/tmp/react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import { ComponentInterface } from '../../../fc-core/src/component-interface';

var _updateDependancyObj = function _updateDependancyObj(a, b, c, d) {
  var e, f;
  (f = d[a]) && (f.some(function (a, d) {
    if (a.callback === b && a.component === c) return e = d, !0;
  }), e !== void 0 && f.splice(e, 1));
};

var InputManager =
/*#__PURE__*/
function (_ComponentInterface) {
  _inherits(InputManager, _ComponentInterface);

  function InputManager() {
    _classCallCheck(this, InputManager);

    return _possibleConstructorReturn(this, _getPrototypeOf(InputManager).apply(this, arguments));
  }

  _createClass(InputManager, [{
    key: "configure",
    value: function configure() {
      var a = this,
          b = a.getFromEnv('chart'),
          c = b.getInputConfigurations;
      a.addToEnv('canvas', a.getLinkedParent()), a.addToEnv('inputOptions', c && c.call(b)), a.config = {
        controlObj: {},
        dependancyObj: {}
      };
    }
  }, {
    key: "addEventToChild",
    value: function addEventToChild() {
      var a = this,
          b = a.getChildren(),
          c = ['zoomin', 'zoomout', 'dragzoomenabled', 'dragzoomdisabled', 'pinenabled', 'pindisabled', 'panenabled', 'pandisabled'];

      var _loop = function _loop(d) {
        c.forEach(function (c) {
          a.addExtEventListener(c, a.manageEvents.bind(a), b[d][0]);
        });
      };

      for (var d in b) {
        _loop(d);
      }
    }
  }, {
    key: "manageEvents",
    value: function manageEvents(a) {
      var b = this.config.dependancyObj,
          c = a.type;
      b[c] && b[c].forEach(function (b) {
        b.component !== a.sender && b.callback.call(b.component, a);
      });
    }
  }, {
    key: "fetchZoomableAxes",
    value: function fetchZoomableAxes() {
      var a = this;

      if (!a.config.axesObArr) {
        var b = a.config.axesObArr = [];
        a.getLinkedParent().getAxes().forEach(function (a) {
          (a.config.zoomable || a.config.pannable) && b.push({
            axis: a.axis,
            stack: [],
            isY: a.isY
          });
        }), a.addToEnv('axesObArr', b);
      }
    }
  }, {
    key: "draw",
    value: function draw() {
      var a = this;
      a.fetchZoomableAxes(), a.addEventToChild();
    }
  }, {
    key: "getControl",
    value: function getControl(a, b) {
      var c,
          d,
          e = this,
          f = e.config.controlObj,
          g = e.getLinkedParent();
      b || a.forEach(function (a) {
        c = a.nativeInteraction, c instanceof Array ? c.forEach(function (b) {
          d = f[b] || (f[b] = []), d.push({
            callback: a.callback,
            component: a.component
          }), a.component.addExtEventListener(b, a.callback, g);
        }) : (d = f[c] || (f[c] = []), d.push({
          callback: a.callback,
          component: a.component
        }), a.component.addExtEventListener(c, a.callback, g));
      });
    }
  }, {
    key: "releaseControl",
    value: function releaseControl(a) {
      var b,
          c = this,
          d = c.getLinkedParent();
      a.forEach(function (a) {
        b = a.nativeInteraction, b instanceof Array ? b.forEach(function (b) {
          a.component.removeExtEventListener(b, a.callback, d), _updateDependancyObj(b, a.callback, a.component, c.config.controlObj);
        }) : (a.component.removeExtEventListener(b, a.callback, d), _updateDependancyObj(b, a.callback, a.component, c.config.controlObj));
      });
    }
  }, {
    key: "_updateControlObj",
    value: function _updateControlObj(a, b) {
      var c,
          d,
          e = this.config.controlObj;
      (d = e[a]) && (d.some(function (a, d) {
        if (a.callback === b) return c = d, !0;
      }), c !== void 0 && d.splice(c, 1));
    }
  }, {
    key: "registerDependancy",
    value: function registerDependancy(a) {
      var b,
          c,
          d = this,
          e = d.config.dependancyObj;
      a.forEach(function (a) {
        b = a.derivedInteraction, b instanceof Array ? b.forEach(function (b) {
          c = e[b] || (e[b] = []), c.push({
            callback: a.callback,
            component: a.component,
            derivedInteraction: b
          });
        }) : (c = e[b] || (e[b] = []), c.push(a));
      });
    }
  }, {
    key: "removeDependancy",
    value: function removeDependancy(a) {
      var b,
          c = this;
      a.forEach(function (a) {
        b = a.derivedInteraction, b instanceof Array ? b.forEach(function (b) {
          _updateDependancyObj(b, a.callback, a.component, c.config.dependancyObj);
        }) : _updateDependancyObj(b, a.callback, a.component, c.config.dependancyObj);
      });
    }
  }, {
    key: "zoomOut",
    value: function zoomOut() {
      var a = this.getChildren('ZoomOutButton');
      a && a[0].zoomOut();
    }
  }, {
    key: "zoomTo",
    value: function zoomTo(a, b) {
      var c = this.getChildren('DragZoomIn');
      c && c[0].zoomTo(a, b);
    }
  }, {
    key: "resetChart",
    value: function resetChart() {
      var a = this.getChildren('ZoomResetButton');
      a && a[0].zoomOut();
    }
  }, {
    key: "setZoomMode",
    value: function setZoomMode(a) {
      var b = this.getChildren('DragPin');
      b && (a ? b[0].disable() : b[0].enable());
    }
  }]);

  return InputManager;
}(ComponentInterface);

export default InputManager;